/**
 * AdminPage - Layout wrapper for admin section with side navigation
 */

import { Menu, Typography } from "antd";
import type { MenuProps } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { MaterialIcon } from "@/components/MaterialIcon";
import AppLayout from "@/components/AppLayout";

const { Title } = Typography;

export default function AdminPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active menu key based on current route
  const getSelectedKey = () => {
    if (location.pathname.includes("/admin/subscriptions")) return "subscriptions";
    if (location.pathname.includes("/admin/mobile-params")) return "mobile-params";
    if (location.pathname.includes("/admin/plans")) return "plans";
    if (location.pathname.includes("/admin/cloud-limits")) return "cloud-limits";
    if (location.pathname.includes("/admin/usb-catalog")) return "usb-catalog";
    if (location.pathname.includes("/admin/beta-codes")) return "beta-codes";
    if (location.pathname.includes("/admin/service-access")) return "service-access";
    if (location.pathname.includes("/admin/users-stats")) return "users-stats";
    return "subscriptions";
  };

  const menuItems: MenuProps["items"] = [
    {
      key: "subscriptions",
      icon: <MaterialIcon name="monitoring" />,
      label: "Subscriptions",
      onClick: () => navigate("/admin/subscriptions"),
    },
    {
      key: "mobile-params",
      icon: <MaterialIcon name="smartphone" />,
      label: "Mobile Params",
      onClick: () => navigate("/admin/mobile-params"),
    },
    {
      key: "plans",
      icon: <MaterialIcon name="payments" />,
      label: "Plans & Pricing",
      onClick: () => navigate("/admin/plans"),
    },
    {
      key: "cloud-limits",
      icon: <MaterialIcon name="cloud" />,
      label: "Cloud Limits",
      onClick: () => navigate("/admin/cloud-limits"),
    },
    {
      key: "usb-catalog",
      icon: <MaterialIcon name="usb" />,
      label: "USB Controllers",
      onClick: () => navigate("/admin/usb-catalog"),
    },
    {
      key: "beta-codes",
      icon: <MaterialIcon name="key" />,
      label: "Beta Codes",
      onClick: () => navigate("/admin/beta-codes"),
    },
    {
      key: "service-access",
      icon: <MaterialIcon name="build" />,
      label: "Service Access",
      onClick: () => navigate("/admin/service-access"),
    },
    {
      key: "users-stats",
      icon: <MaterialIcon name="groups" />,
      label: "Users Stats",
      onClick: () => navigate("/admin/users-stats"),
    },
  ];

  return (
    <AppLayout>
      <div style={{ display: "flex", gap: 24, minHeight: "100%" }}>
        {/* Admin side menu */}
        <div style={{ width: 200, flexShrink: 0 }}>
          <Title level={4} style={{ marginBottom: 16 }}>
            <MaterialIcon name="admin_panel_settings" style={{ marginRight: 8 }} />
            Admin
          </Title>
          <Menu
            mode="inline"
            selectedKeys={[getSelectedKey()]}
            items={menuItems}
            style={{ border: "none", background: "transparent" }}
          />
        </div>

        {/* Admin content area */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </div>
      </div>
    </AppLayout>
  );
}
